<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <LinkTrackerAndSimcard v-if="active" :active="active" />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import LinkTrackerAndSimcard from '@/components/settings/stock-registers/active/LinkTrackerAndSimcard.vue'

  export default {
    name: 'LinkTrackerAndSimcards',
    components: {
      PageTitle,
      PageRowWrapper,
      LinkTrackerAndSimcard
    },
    computed: {
      ...mapState({
        active: state => state.active.activeById
      })
    },
    methods: {
      ...mapActions('active', ['fetchById'])
    },
    mounted () {
      this.fetchById(this.$route.params.id)
    }
  }
</script>
